import { CircleCheck } from "lucide-react";
import { LARGE_ICON_SIZE_STYLES } from "../../ui/styles";

const registerBenefits = [
  "10,000 Items",
  "10,000 Calls",
  "Freemium*",
  "No payment details required.",
];

export const RegisterPromo = (
  <div className="mx-auto justify-center -mb-6 mt-4 w-4/5 sm:max-w-md">
    <div className="flex flex-wrap gap-3 justify-center">
      {registerBenefits.map((item, index) => (
        <div
          key={index}
          className="flex min-w-max gap-2 align-middle text-sm font-medium text-stone-700 dark:text-stone-300"
        >
          <CircleCheck className={`text-green-500 ${LARGE_ICON_SIZE_STYLES}`} />
          <span className="my-auto">{item}</span>
        </div>
      ))}
    </div>
    <p className="text-xs text-center mt-2 text-stone-600 dark:text-stone-400">
      * We reserve the right to end the freemium offer with three months’
      notice.
    </p>
  </div>
);
